<button class="signmail" (click)="handleGoogleLogin()" type="button">
    <img src="assets/images/google.svg" alt="google"> Google.
</button>
